import {DataTable} from "./datatable/DataTable";
import {formatPrice, sumItemsDouble} from "../js/util";
import {OrderTotal} from "./OrderTotal";
import {Fragment, useEffect, useState} from "react";
import {SelectReact} from "./form/SelectReact";
import {get} from "../js/api";

export const OrderShippingAndTotal = ({orderItems, shipping, updateShippingFunction = null}) => {
    const [selectedShipping, setSelectedShipping] = useState(null);
    const [availableShipping, setAvailableShipping] = useState([]);
    const [shippingSelectOptions, setShippingSelectOptions] = useState([]);

    useEffect(() => {
        get("/public/shippings").then(shippings => {
            //add the current if it's not available so it stays selectable
            if(shippings.filter(s => s.title == shipping.title).length == 0){
                shippings.push(shipping);
            }

            setAvailableShipping(shippings);
            const options = [];
            shippings.forEach(s => options.push({value: s.id, label: s.title + " (" + s.price + " €)"}));

            setShippingSelectOptions(options);
        });
    }, [])

    useEffect(() => {
        setSelectedShipping(shipping.id);
    }, [shippingSelectOptions, shipping]);

    const shippingColumn = [
        {
            name: <Fragment>
                {updateShippingFunction && <SelectReact name="versandoption" label="Versandoption" value={selectedShipping} menuPortalTarget={document.body} options={shippingSelectOptions}
                                                     setter={(newValue) => updateShippingFunction(availableShipping.find(s => s.id == newValue))}/>}
                {!updateShippingFunction && <Fragment>Versand: {shipping.title}</Fragment>}
            </Fragment>,
            grow: 1,
            right: true,
            selector: (row) => formatPrice(shipping.price),
        }
    ];

    return (
        <div className="right">
            <div className={"data-table mt-0 no-hover inline-block " + (updateShippingFunction ? 'updateable-shipping-table' : '')} style={{ width: updateShippingFunction ? '600px' : '400px', maxWidth: '100%'}}>
                <DataTable data={[{}]}
                           columns={shippingColumn}
                           noHeader
                           noSearch
                           removeTopPadding/>
            </div>
            <br/>
            <OrderTotal orderItems={orderItems} shipping={shipping}/>
        </div>
    );

};